export class CatalogsService {
  constructor($http, DropdownItemsFactory, $translate, $state) {
    this.$http = $http;
    this.DropdownItemsFactory = DropdownItemsFactory;
    this.$translate = $translate;
    this.$state = $state;
  }


  static CatalogsFactory($http, DropdownItemsFactory, $translate, $state) {
    return new CatalogsService($http, DropdownItemsFactory, $translate, $state);
  }

  goToCatalogs() {
    this.$state.go('auth.alcmeon.fuse.parameters.catalogs');
  }
}

CatalogsService.CatalogsFactory.$inject = ['$http', 'DropdownItemsFactory', '$translate', '$state'];

